"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WsConnector = void 0;
const safejson_1 = require("../utils/safejson");
const log_1 = require("../utils/log");
class WsConnector {
    constructor() {
        this.disconnectListener = [];
        this.walletName = '';
        this.walletNameKey = '';
        this.enable = true;
        this.pendingRequests = new Map();
        // report api begin
        (0, log_1.getDefaultReporter)().beginReport();
    }
    setAccountChangeListener(accountChangeListener) {
        this.accountChangeListener = accountChangeListener;
    }
    setConnectionManager(connectionManager) {
        this.connectionManager = connectionManager;
    }
    addConnectionListener() {
        var _a;
        (_a = this.connectionManager) === null || _a === void 0 ? void 0 : _a.addListener("sdk_response", (event, msg) => {
            var jsonResponse = (0, safejson_1.safeJsonParse)(msg);
            (0, log_1.logDebug)(`Engine ==>> addListener ==> success ==> ${jsonResponse}`);
            this.handleResponse(event, jsonResponse);
        }, function () {
        });
    }
    addDisconnectListener(disconnecter) {
        this.disconnectListener.push(disconnecter);
    }
    connectManagerDisconnect() {
        return __awaiter(this, arguments, void 0, function* (fromRestore = false) {
            var _a;
            yield ((_a = this.connectionManager) === null || _a === void 0 ? void 0 : _a.disconnect(fromRestore));
        });
    }
    openWallet(engineConnectInfo, openAppLinkType) {
    }
    bindRequestForPromise(requestId, resolve) {
        this.pendingRequests.set(requestId, resolve);
    }
    send(request, requestAnswer, ttl) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            try {
                delete request.injectParams;
            }
            catch (e) {
            }
            (0, log_1.logDebug)('Engine ==>> send  request==>', JSON.stringify(request));
            const requestId = this.getRequestId();
            try {
                let packageId = yield ((_a = this.connectionManager) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify(Object.assign(Object.assign({}, request), { requestId: requestId })), ttl));
                if (packageId) {
                    (_b = this.connectionManager) === null || _b === void 0 ? void 0 : _b.events.once(packageId.toString(), (event) => {
                        var _a;
                        (0, log_1.logDebug)(`Engine ==> send => onAck => ${(0, safejson_1.safeJsonStringify)(event)}`);
                        if (event && event.result) {
                            (_a = requestAnswer.onAck) === null || _a === void 0 ? void 0 : _a.call(requestAnswer);
                        }
                    });
                }
                if (requestAnswer.resolve) {
                    this.bindRequestForPromise(requestId, requestAnswer.resolve);
                }
            }
            catch (e) {
                return Promise.reject(e);
            }
        });
    }
    restoreconnect(sessionInfo, onConnectResult) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            yield ((_a = this.connectionManager) === null || _a === void 0 ? void 0 : _a.restoreConnect(sessionInfo.topic));
            onConnectResult(sessionInfo);
        });
    }
    restoreconnectFromTopic(topic) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            yield ((_a = this.connectionManager) === null || _a === void 0 ? void 0 : _a.restoreConnect(topic));
        });
    }
    getRequestId() {
        const requestId = Date.now().toString();
        (0, log_1.logDebug)('Engine ==>> getRequestId ==>', requestId);
        return requestId;
    }
    handleResponse(event, response) {
        (0, log_1.logDebug)(`Engine ==>> handleResponse_1  ======>response: ${(0, safejson_1.safeJsonStringify)(response)}`, event);
        if ("requestId" in response) {
            (0, log_1.logDebug)("Engine ==>> handleResponse_2  ===> in response");
            let requestId = response.requestId;
            const resolve = this.pendingRequests.get(requestId);
            if (resolve) {
                (0, log_1.logDebug)("Engine ==>> handleResponse_3  ===> find resolve:", resolve);
                resolve(response);
                // 从pendingRequests中删除这个Promise
                this.pendingRequests.delete(requestId);
            }
            else {
                (0, log_1.logDebug)("Engine ==>> handleResponse_3  ===> not find resolve:");
                if (response.method === "disconnect") {
                    this.disconnectListener.forEach(listener => listener());
                    this.disconnectListener = [];
                    this.clearData();
                }
            }
        }
    }
    getCurrentConnectionReady() {
        var _a;
        return !!((_a = this.connectionManager) === null || _a === void 0 ? void 0 : _a.getCurrentConnectionReady());
    }
    saveSessionContent(key, data) {
        var _a;
        (_a = this.connectionManager) === null || _a === void 0 ? void 0 : _a.saveSessionContent(key, data);
    }
    getSessionContent(key) {
        var _a;
        return (_a = this.connectionManager) === null || _a === void 0 ? void 0 : _a.getSessionContent(key);
    }
    setOnConnectResultListener(connectResultListener) {
        this.connectResultListener = connectResultListener;
    }
    getTag() {
        return "";
    }
    toJSON() {
        return "ws-connector";
    }
    clearData() {
        this.pendingRequests.clear();
    }
}
exports.WsConnector = WsConnector;
